// extracted by css-extract-rspack-plugin
export default {"heading":"CompletedChecks-module__heading__HiQSU","middot":"CompletedChecks-module__middot__p3EGU","summary":"CompletedChecks-module__summary__xu6Or"};